<template>
  <button
    class='button button-primary'
    @click.stop.prevent="emitClick"
    :disabled="loading">
      <slot v-if="!loading"></slot>
      <div v-if="loading">
        <div class="spinner is-active"></div>
        <p class="screen-reader-text">Button for form disabled until request has processed.</p>
      </div>
  </button>
</template>

<script>
export default {
  name: "AcButton",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitClick() {
      this.$emit("click");
    }
  }
};
</script>



// WEBPACK FOOTER //
// admin/src/js/components/AcButton.vue